<template>
  <a-form-item
    v-if="field.type !== 'divider' && (field?.is_search_show !== false || field_render_show)"
    :label="field.label"
    :name="field.name"
    :extra="field.extra"
    v-bind="validateInfos[field.name]"
  >
    <a-input
      v-if="field.type === 'input'"
      size="small"
      v-model:value="model"
      :placeholder="field.placeholder"
      :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
      :disabled="field.disabled"
      :default-value="field.defaultValue"
      :allow-clear="field.allowClear"
      :type="field.type ? field.type : 'input'"
      :maxlength="field.maxlength"
    />

    <a-textarea
      v-if="field.type === 'textarea'"
      v-model:value="model"
      :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
      :placeholder="field.placeholder"
      :disabled="field.disabled"
      :allow-clear="field.allowClear"
      :autoSize="{ minRows: 5 }"
    />

    <a-input-number
      v-if="field.type === 'number'"
      size="small"
      v-model:value="model"
      :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
      :disabled="field.disabled"
      :default-value="field.defaultValue"
      :min="field.min"
      :max="field.max"
      :formatter="field.formatter"
      :parser="field.parser"
      :precision="field.precision"
      :step="field.step"
      :placeholder="field.placeholder"
      style="width: 100%"
    />
    <a-input-password
      v-if="field.type === 'password'"
      size="small"
      v-model:value="model"
      :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
      :disabled="field.disabled"
      :default-value="field.defaultValue"
      :min="field.min"
      :max="field.max"
      :formatter="field.formatter"
      :precision="field.precision"
      :step="field.step"
      :placeholder="field.placeholder"
      style="width: 100%"
    />
    <template v-if="field.type === 'select'">
      <a-select
        size="small"
        v-if="field.mode === 'default'"
        v-model:value="model"
        style="min-width: 150px"
        :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
        :show-search="!!field.show_search"
        :disabled="field.disabled"
        :placeholder="field.placeholder"
        :default-value="field.defaultValue"
        :allow-clear="field.allowClear"
        :maxTagCount="field.maxTagCount"
      >
        <a-select-option
          v-for="option in options"
          :key="option[field.valueKey ? field.valueKey : 'value']"
          :value="option[field.valueKey ? field.valueKey : 'value']"
        >
          {{ option[field.labelKey ? field.labelKey : 'label'] }}
        </a-select-option>
      </a-select>
      <a-select
        v-else
        size="small"
        v-model:value="model"
        style="min-width: 150px"
        :show-search="!!field.show_search"
        :disabled="field.disabled"
        :placeholder="field.placeholder"
        :default-value="field.defaultValue"
        :allow-clear="field.allowClear"
        :mode="field.mode"
        :maxTagCount="field.maxTagCount"
      >
        <a-select-option
          v-for="(option, index) in options"
          :key="index"
          :value="option[field.valueKey ? field.valueKey : 'value']"
        >
          {{ option[field.labelKey ? field.labelKey : 'label'] }}
        </a-select-option>
      </a-select>
    </template>

    <a-cascader
      v-if="field.type === 'cascader'"
      v-model:value="model"
      size="small"
      :disabled="field.disabled"
      :options="options"
      :placeholder="field.placeholder"
      :default-value="field.defaultValue"
      :allow-clear="field.allowClear"
    />

    <a-month-picker
      v-if="field.type === 'monthpicker'"
      size="small"
      v-model:value="model"
      :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
      :disabled="field.disabled"
      :allow-clear="field.allowClear"
      :default-value="field.defaultValue"
      :format="field.format"
      :value-format="field.valueFormat"
      :show-time="field.showTime"
      :placeholder="field.placeholder"
      style="width: 100%"
    />
    <a-date-picker
      v-if="field.type === 'datepicker'"
      size="small"
      v-model:value="model"
      :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
      :disabled="field.disabled"
      :allow-clear="field.allowClear"
      :default-value="field.defaultValue"
      :format="field.format"
      :value-format="field.valueFormat"
      :show-time="field.showTime"
      :placeholder="field.placeholder"
      style="width: 100%"
    />

    <a-range-picker
      size="small"
      v-if="field.type === 'rangepicker'"
      v-model:value="model"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :allow-clear="field.allowClear"
      :format="field.format"
      :value-format="field.valueFormat"
      :show-time="field.showTime"
      :placeholder="field.placeholder"
      style="width: 100%"
    />

    <a-time-picker
      size="small"
      v-if="field.type === 'timepicker'"
      v-model:value="model"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :allow-clear="field.allowClear"
      :format="field.format"
      :value-format="field.valueFormat"
      :placeholder="field.placeholder"
      style="width: 100%"
    />

    <a-radio-group
      size="small"
      v-if="field.type === 'radio'"
      v-model:value="model"
      :disabled="field.disabled"
      :default-value="field.defaultValue"
    >
      <a-radio
        v-for="option in options"
        :key="option[field.valueKey ? field.valueKey : 'value']"
        :value="option[field.valueKey ? field.valueKey : 'value']"
        :disabled="option.disabled"
      >
        {{ option[field.labelKey ? field.labelKey : 'label'] }}
      </a-radio>
    </a-radio-group>

    <a-checkbox-group
      size="small"
      v-if="field.type === 'checkbox'"
      v-model:value="model"
      :disabled="field.disabled"
      :default-value="field.defaultValue"
    >
      <a-checkbox
        v-for="option in options"
        :key="option[field.valueKey ? field.valueKey : 'value']"
        :value="option[field.valueKey ? field.valueKey : 'value']"
        :disabled="option.disabled"
      >
        {{ option[field.labelKey ? field.labelKey : 'label'] }}
      </a-checkbox>
    </a-checkbox-group>

    <a-tree-select
      size="small"
      v-if="field.type === 'treeselect'"
      v-model:value="model"
      :placeholder="field.placeholder"
      :disabled="field.disabled"
      :default-value="field.defaultValue"
      :allow-clear="field.allowClear"
      :tree-data="options"
      :tree-checkable="field.multiple"
      :tree-node-filter-prop="field.valueKey"
      :tree-label-prop="field.labelKey"
    />
    <remote-select
      v-if="field.type === 'remoteselect'"
      v-model:value="model"
      :field="field"
      :formModel="formModel"
      :get-data="field.getData"
      :label-key="field.labelKey"
      :value-key="field.valueKey"
      :label-key-list="field.labelKeyList"
      :label-space="field.labelSpace"
      :init_model="field.init_model"
      :search_config="field.search_config"
    />
    <remote-tree-select
      v-if="field.type === 'remotetreeselect'"
      v-model:value="model"
      :field="field"
      :formModel="formModel"
      :get-data="field.getData"
      :label-key="field.labelKey"
      :value-key="field.valueKey"
      :search_config="field.search_config"
      :disabled="field.disabled"
      :default-value="field.defaultValue"
      :allow-clear="field.allowClear"
    />
    <remote-modal
      v-if="field.type === 'remotemodal'"
      v-model:value="model"
      :field="field"
      :formModel="formModel"
      :columns="field.columns"
      :init_model="field.init_model"
      :field_status="field.field_status"
      :watch="field.watch"
      :get-data="field.getData"
      :modalType="field.modalType"
      :search_config="field.search_config"
    />
  </a-form-item>

  <a-divider v-if="field.type === 'divider'" :orientation="field.orientation">
    {{ field.label }}
  </a-divider>
</template>
<script lang="ts">
import RemoteSelect from '@/components/FormRender/RemoteSelect/RemoteSelect.vue';
import RemoteModal from '@/components/FormRender/RemoteModal/RemoteModal.vue';
import RemoteTreeSelect from '@/components/FormRender/RemoteTreeSelect/RemoteTreeSelect.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'FieldRender',
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      required: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
    validateInfos: {
      type: Object,
      default: () => {},
    },
    formModel: {
      type: Object,
      default: () => {},
    },
    field_render_show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      model: this.value,
    };
  },
  watch: {
    model: {
      handler(newValue) {
        this.$emit('update:value', newValue);
      },
    },
    value: {
      handler(newValue) {
        this.model = newValue;
      },
    },
  },
  created() {},
  components: {
    RemoteModal,
    RemoteSelect,
    RemoteTreeSelect,
  },
});
</script>

<style scoped>
.ant-calendar-picker {
  width: 100% !important;
}
</style>
